import React from 'react';
import { getComparisonStatus } from './frfBaseline';

const FrfComparisonStatus = ({ frequencyDifferences, amplitudeDifferences }) => {
  const status = getComparisonStatus(frequencyDifferences, amplitudeDifferences);

  if (!status) {
    return <div className="frf-comparison-status" aria-hidden="true" />;
  }

  return (
    <div
      className={`frf-comparison-status frf-comparison-status-${status.toLowerCase()}`}
      role="status"
      aria-live="polite"
      aria-label={`峰值比對結果：${status}`}
    >
      {status}
    </div>
  );
};

export default FrfComparisonStatus;
